module.exports = __webpack_public_path__ + "img/notice.1ed3e033.png";